import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { combineLatest, startWith, Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'app-financial-form',
	templateUrl: './financial-form.component.html',
	styleUrls: ['./financial-form.component.scss'],
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, TranslateModule, IonicModule],
})
export class FinancialFormComponent implements OnDestroy {
	modalController = inject(ModalController);

	form = new FormGroup({
		netAmount: new FormControl<number>(0),
		optionPurchase: new FormControl<number>(100),
		percentage: new FormControl<number>(10),

    cost: new FormControl<number>(0),
		anticipAmount: new FormControl<number>(0),
		processingFees: new FormControl<number>(200),
		partialAmount: new FormControl<number>(0),
		canonAmount: new FormControl<number>(0),
		totalAmount: new FormControl<number>(0),
	});

	private destroy$ = new Subject<void>();

	updater$ = combineLatest([
		this.form.controls.netAmount.valueChanges.pipe(startWith(0)),
		this.form.controls.optionPurchase.valueChanges.pipe(startWith(100)),
		this.form.controls.percentage.valueChanges.pipe(startWith(10)),
	]);

	constructor() {
		this.updater$.pipe(takeUntil(this.destroy$)).subscribe(([netAmount, optionPurchase, percentage]) => {
      const anticipAmount = (netAmount * percentage) / 100;
      const partialAmount = anticipAmount + 200;
      const canonAmount = (netAmount * 17) / 1000
      const totalAmount = netAmount > 0 ? optionPurchase + partialAmount + (canonAmount * 59) : 0;

      this.form.patchValue({
        cost: netAmount,
        anticipAmount: anticipAmount,
        partialAmount: partialAmount,
        canonAmount: canonAmount,
        totalAmount: totalAmount,
      });
      this.form.updateValueAndValidity({ emitEvent: false });
    });
	}

	dismiss() {
		this.modalController.dismiss();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}

/**
 * 100 - netto
 * 100
 * 5 anni
 * mensile
 * 1 - opzione acquisto
 * 10%
 * 10 - importo anticipo
 * 200
 * 210 - anticipo + spesa istruttoria
 * 59
 * 1,7
 * 311,3 - costo totale
 */
